import i18next from 'i18next';

/** Єдиний екземпляр i18next застосунку; налаштовується setupI18n, пакети модулів додають namespace `module.<ключ>` через loadModule. */
export const i18n = i18next;
